import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    headerTitle: translate({ id: 'settings.rmAccount.edit.header.title' }),
    headerDescription: translate({ id: 'settings.rmAccount.edit.header.description' }),
    save: translate({ id: 'settings.rmAccount.edit.footer.save' }),
    cancel: translate({ id: 'settings.rmAccount.edit.footer.cancel' }),

    nameRequired: translate({ id: 'settings.rmAccount.edit.errors.name.required' }),
    nameMaxLength: translate({ id: 'settings.rmAccount.edit.errors.name.maxLength' }),

    surnameRequired: translate({ id: 'settings.rmAccount.edit.errors.surname.required' }),
    surnameMaxLength: translate({ id: 'settings.rmAccount.edit.errors.surname.maxLength' }),

    emailRequired: translate({ id: 'settings.rmAccount.edit.errors.email.required' }),
    emailValid: translate({ id: 'settings.rmAccount.edit.errors.email.invalid' }),

    usernameRequired: translate({ id: 'settings.rmAccount.edit.errors.username.required' }),
    usernameMinLength: translate({ id: 'settings.rmAccount.edit.errors.username.minLength' }),
    usernameMaxLength: translate({ id: 'settings.rmAccount.edit.errors.username.maxLength' }),
    usernameNonUnique: translate({ id: 'settings.rmAccount.edit.errors.username.nonUnique' }),
    allowedCharacters: translate({
      id: 'settings.rmAccount.edit.errors.username.allowedCharacters',
    }),
  }))

  return api
}
